export const salesDashboardUr = {
  salesDashboard: {
    title: 'سیلز ڈیش بورڈ',
    subtitle: 'ڈیلیوری کی مقدار، موازنہ، اور ہدف ٹریکنگ',
    loading: 'لوڈ ہو رہا ہے...',
    noData: 'کوئی ڈیٹا دستیاب نہیں',
    lastUpdated: 'آخری اپ ڈیٹ',
    stats: {
      totalTons: 'کل ڈیلیوری',
      deliveries: 'ڈیلیوریز',
      totalTrips: 'کل ٹرپس',
      change: 'مدت تبدیلی',
      changeTons: 'تبدیلی (ٹن)',
      tons: 'ٹن',
      increase: 'اضافہ',
      decrease: 'کمی',
      noChange: 'کوئی تبدیلی نہیں',
      daysWithData: 'فعال دن',
      activeDays: 'فعال دن',
      days: 'دن',
      avgDaily: 'روزانہ اوسط',
      tonsPerDay: 'ٹن/دن',
      vsPreviousPeriod: 'پچھلی مدت کے مقابلے',
      vsSamePeriodLastYear: 'پچھلے سال کی اسی مدت کے مقابلے',
      current: 'موجودہ',
      previous: 'پچھلا',
    },
    chart: {
      dailyTitle: 'روزانہ ڈیلیوری کی مقدار',
      comparisonTitle: 'موازنہ',
      deliveredTons: 'ڈیلیوری (ٹن)',
    },
    comparison: {
      dod: 'دن/دن',
      wow: 'ہفتہ/ہفتہ',
      mom: 'مہینہ/مہینہ',
      dodFull: 'دن بمقابلہ دن',
      wowFull: 'ہفتہ بمقابلہ ہفتہ',
      momFull: 'مہینہ بمقابلہ مہینہ',
    },
    breakdown: {
      label: 'تقسیم بلحاظ',
      none: 'کوئی تقسیم نہیں',
      title: 'تقسیم',
      factory: 'فیکٹری',
      customer: 'کسٹمر',
      city: 'ڈیلیوری مقام',
      sku: 'پروڈکٹ',
      variant: 'پروڈکٹ',
      name: 'نام',
      currentTons: 'موجودہ (ٹن)',
      currentOrders: 'آرڈرز (موجودہ)',
      previousTons: 'پچھلا (ٹن)',
      previousOrders: 'آرڈرز (پچھلا)',
      changePct: 'تبدیلی %',
    },
    dateRange: {
      today: 'آج',
      yesterday: 'کل',
      thisWeek: 'اس ہفتے',
      lastWeek: 'پچھلا ہفتہ',
      thisMonth: 'اس مہینے',
      lastMonth: 'پچھلا مہینہ',
      thisQuarter: 'اس سہ ماہی',
      thisYear: 'اس سال',
      last30Days: 'پچھلے 30 دن',
      custom: 'حسب ضرورت',
    },
    filters: {
      label: 'فلٹرز',
      searchFactory: 'فیکٹریاں تلاش کریں...',
      searchCustomer: 'کسٹمرز تلاش کریں...',
      searchCity: 'شہر تلاش کریں...',
      searchProduct: 'مصنوعات تلاش کریں...',
      clearAll: 'تمام فلٹرز صاف کریں',
      noResults: 'کوئی نتیجہ نہیں ملا۔',
      loading: 'لوڈ ہو رہا ہے...',
      clear: 'صاف کریں',
    },
    export: {
      button: 'برآمد',
      downloading: 'برآمد ہو رہا ہے...',
      sheetDaily: 'روزانہ فروخت',
      sheetBreakdown: 'تقسیم',
      colDate: 'تاریخ',
      colTons: 'ڈیلیوری (ٹن)',
      colDeliveries: 'ڈیلیوریز',
      colName: 'نام',
      colCurrentTons: 'موجودہ (ٹن)',
      colCurrentOrders: 'آرڈرز (موجودہ)',
      colPreviousTons: 'پچھلا (ٹن)',
      colPreviousOrders: 'آرڈرز (پچھلا)',
      colChangePct: 'تبدیلی %',
    },
    targets: {
      title: 'ماہانہ اہداف',
      subtitle: 'فیکٹری کے مطابق ڈیلیوری اہداف کا انتظام',
      progressTitle: 'ہدف کی پیشرفت',
      remaining: 'باقی',
      addTarget: 'ہدف شامل کریں',
      editTarget: 'ہدف میں ترمیم',
      month: 'مہینہ',
      factory: 'فیکٹری',
      selectFactory: 'فیکٹری منتخب کریں',
      variant: 'پروڈکٹ',
      allVariants: 'تمام مصنوعات (کل)',
      variantHint: 'فیکٹری سطح کے کل ہدف کے لیے "تمام مصنوعات" چھوڑ دیں',
      targetQuantity: 'ہدف مقدار',
      notes: 'نوٹس',
      empty: 'کوئی اہداف نہیں',
      status: 'حالت',
      current: 'موجودہ',
      past: 'گزشتہ',
      future: 'آئندہ',
      total: 'کل',
      deleteConfirmTitle: 'ہدف حذف کریں',
      deleteConfirmDescription: 'کیا آپ واقعی یہ ہدف حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں ہو سکتا۔',
      deleteConfirmAction: 'حذف کریں',
      allMonths: 'تمام مہینے',
      totalTargets: 'کل اہداف',
      totalQuantity: 'کل مقدار',
      factoriesCovered: 'فیکٹریاں',
      avgPerFactory: 'فی فیکٹری اوسط',
      manageTargets: 'اہداف کا انتظام',
      noTargetsForMonth: 'اس مہینے کے لیے کوئی اہداف نہیں ہیں۔ ڈیلیوری کی پیشرفت کو ٹریک کرنے کے لیے اہداف مقرر کریں۔',
      monthsWithTargets: '{{count}} مہینے اہداف کے ساتھ',
      validation: {
        monthFormat: 'فارمیٹ: YYYY-MM',
        required: 'ضروری ہے',
        positive: 'مثبت نمبر ہونا چاہیے',
      },
    },
    subCustomers: {
      admin: {
        title: 'ذیلی کسٹمرز ڈیش بورڈ',
        subtitle: 'ذیلی کسٹمر کے لحاظ سے ڈیلیور شدہ آرڈرز اور ٹن',
        entity: 'ذیلی کسٹمر',
        code: 'ذیلی کسٹمر کوڈ',
        active: 'فعال ذیلی کسٹمرز',
        total: 'ذیلی کسٹمرز کے ٹن',
        topTitle: 'سرفہرست 20 ذیلی کسٹمرز',
        searchPlaceholder: 'نام یا کوڈ سے ذیلی کسٹمر تلاش کریں…',
        noSubCustomer: 'بغیر ذیلی کسٹمر',
        exportThis: 'یہ ذیلی کسٹمر ایکسپورٹ کریں',
        exportDescription: 'ہر ڈیلیور شدہ آرڈر جس کا ذیلی کسٹمر ہو اور جو صفحے کے فلٹرز اور اوپر منتخب پلانٹ/کسٹمر سے مطابقت رکھتا ہو۔',
      },
      customer: {
        title: 'گاہکوں کا ڈیش بورڈ',
        subtitle: 'گاہک کے لحاظ سے ڈیلیور شدہ آرڈرز اور ٹن',
        entity: 'گاہک',
        code: 'گاہک کوڈ',
        active: 'فعال گاہک',
        total: 'گاہکوں کے ٹن',
        topTitle: 'سرفہرست 20 گاہک',
        searchPlaceholder: 'نام یا کوڈ سے گاہک تلاش کریں…',
        noSubCustomer: 'بغیر گاہک',
        exportThis: 'یہ گاہک ایکسپورٹ کریں',
        exportDescription: 'ہر ڈیلیور شدہ آرڈر جس کا گاہک ہو اور جو صفحے کے فلٹرز اور اوپر منتخب پلانٹ سے مطابقت رکھتا ہو۔',
      },
      mainCustomer: 'مرکزی کسٹمر',
      plant: 'پلانٹ',
      city: 'شہر',
      cementType: 'سیمنٹ کی قسم',
      orders: 'آرڈرز',
      tons: 'ٹن',
      ordersUnit: 'آرڈرز',
      share: 'حصہ',
      rank: '#',
      date: 'تاریخ',
      unknownCustomer: 'نامعلوم کسٹمر',
      unknown: 'نامعلوم',
      other: 'دیگر',
      noData: 'ان فلٹرز سے کوئی ڈیلیوری مطابقت نہیں رکھتی',
      lockedHint: 'اوپر سے منتخب',
      rangeTooLong: '{{days}} دن یا اس سے کم کی مدت منتخب کریں',
      view: { label: 'منظر', chart: 'چارٹ', table: 'جدول' },
      kpi: {
        orders: 'ڈیلیور شدہ آرڈرز',
        avgTonsPerOrder: 'فی آرڈر اوسط ٹن',
      },
      charts: {
        trend: 'روزانہ ڈیلیور شدہ ٹن اور آرڈرز',
        byCementType: 'سیمنٹ کی قسم کے لحاظ سے',
        byCity: 'شہر کے لحاظ سے',
        byPlant: 'پلانٹ کے لحاظ سے',
      },
      filters: {
        button: 'فلٹرز',
        title: 'فلٹرز',
        dateRange: 'مدت',
        clearAll: 'سب صاف کریں',
        done: 'مکمل',
      },
      search: { noResults: 'کوئی نتیجہ نہیں', minChars: 'کم از کم 2 حروف لکھیں', searching: 'تلاش جاری ہے…' },
      detail: {
        cities: 'شہر',
        plants: 'پلانٹس',
        cementTypes: 'سیمنٹ کی اقسام',
      },
      export: {
        button: 'ایکسپورٹ',
        title: 'آرڈرز ایکسپورٹ کریں',
        dateLabel: 'مدت',
        download: 'ڈاؤن لوڈ',
        cancel: 'منسوخ',
        only: 'صرف',
        empty: 'اس مدت میں ایکسپورٹ کے لیے کوئی آرڈر نہیں',
        narrowRange: 'ایک فائل کے لیے آرڈرز بہت زیادہ ہیں (حد 50,000 آرڈرز اور زیادہ سے زیادہ 366 دن)۔ مدت کم کریں۔',
        failed: 'ایکسپورٹ ناکام ہو گیا',
        sheet: 'آرڈرز',
        colOrderNumber: 'آرڈر نمبر',
        colDeliveryDay: 'ڈیلیوری کا دن',
      },
      error: { title: 'ڈیش بورڈ لوڈ نہیں ہو سکا', retry: 'دوبارہ کوشش کریں' },
    },
  },
}
